// extracted by mini-css-extract-plugin
module.exports = {"primaryContent":"ArtistPageLayout_primaryContent__tfPz_"};